Function.prototype.after = function(timeout, boundTo = null, args = null)
{
	var self = this;
	if (boundTo)
		self = self.bind.apply(self, [ boundTo ].concat(args || []));
	return setTimeout(self, timeout);
};
